import { memo } from 'react';

import { Link } from '@air/next-icons';
import { Button, type ButtonProps } from '@air/primitive-button';
import { Tooltip } from '@air/primitive-tooltip';

export type ShareButtonProps = Pick<Required<ButtonProps>, 'onClick'> & Pick<ButtonProps, 'color'>;

export const ShareButton = memo(({ onClick, color = 'blue' }: ShareButtonProps) => (
  <Tooltip label="Share">
    <Button
      prefix={<Link className="size-4" />}
      appearance="filled"
      color={color}
      onClick={onClick}
      size="small"
      className="ui2:rounded-4"
    >
      Share
    </Button>
  </Tooltip>
));

ShareButton.displayName = 'ShareButton';
